export const checkLink = function (url) {
  var bol = false;
  var pattern = /\b((?:[a-z][\w\-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]|\((?:[^\s()<>]|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]|(?:\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/i
  bol = !!pattern.exec(url.toLowerCase())
  return bol;
}

export const getParameter = function (name) {
  let r = new RegExp('(\\?|#|&)' + name + '=([^&#]*)(&|#|$)')
  let m = location.href.match(r)
  return decodeURIComponent(!m ? '' : m[2])
}

export const getUrl = function () {
  let url = window.location.href
  url = url.split('url=')[1]
  return decodeURIComponent(url)
}